import { render, staticRenderFns } from "./QuoteCard.vue?vue&type=template&id=4897030c&scoped=true"
import script from "./QuoteCard.vue?vue&type=script&lang=js"
export * from "./QuoteCard.vue?vue&type=script&lang=js"
import style0 from "./QuoteCard.vue?vue&type=style&index=0&id=4897030c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4897030c",
  null
  
)

export default component.exports